function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Suggest } from "@blueprintjs/select";
import { Keys } from "@blueprintjs/core";
import React from "react";
import fuzzysearch from "fuzzysearch";
import classNames from "classnames";

var TgSuggest = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TgSuggest, _React$Component);

  function TgSuggest() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "itemRenderer", function (i, _ref) {
      if (i === void 0) {
        i = "";
      }

      var index = _ref.index,
          handleClick = _ref.handleClick,
          modifiers = _ref.modifiers;
      return /*#__PURE__*/React.createElement("div", {
        //we specifically don't use a BP MenuItem component here because the menu item is too slow when 100s are loaded and will cause the component to lag
        onClick: handleClick,
        key: index,
        className: classNames("tg-select-option bp3-menu-item bp3-fill bp3-text-overflow-ellipsis", {
          "bp3-active": modifiers.active
        })
      }, i);
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelect", function (item) {
      var onChange = _this.props.onChange;
      _this.input && _this.input.blur();
      return onChange(item);
    });

    _defineProperty(_assertThisInitialized(_this), "itemPredicate", function (queryString, item) {
      var isSimpleSearch = _this.props.isSimpleSearch;
      return singleItemPredicate(queryString, item, isSimpleSearch);
    });

    _defineProperty(_assertThisInitialized(_this), "onQueryChange", function (query) {
      var onChange = _this.props.onChange;
      onChange(query);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInputValue", function (item) {
      return item;
    });

    return _this;
  }

  var _proto = TgSuggest.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        multi = _this$props.multi,
        options = _this$props.options,
        notCreateable = _this$props.notCreateable,
        value = _this$props.value,
        optionRenderer = _this$props.optionRenderer,
        noResultsText = _this$props.noResultsText,
        inputProps = _this$props.inputProps,
        placeholder = _this$props.placeholder,
        isLoading = _this$props.isLoading,
        onBlur = _this$props.onBlur,
        disabled = _this$props.disabled,
        popoverProps = _this$props.popoverProps,
        rest = _objectWithoutPropertiesLoose(_this$props, ["multi", "options", "notCreateable", "value", "optionRenderer", "noResultsText", "inputProps", "placeholder", "isLoading", "onBlur", "disabled", "popoverProps"]);

    return /*#__PURE__*/React.createElement(Suggest, _extends({
      closeOnSelect: true,
      items: options || [],
      query: value,
      popoverProps: _extends({
        minimal: true,
        className: classNames("tg-select", {
          "tg-single-select": !multi
        }),
        wrapperTagName: "div",
        usePortal: false,
        canEscapeKeyClose: true
      }, popoverProps),
      onKeyDown: function onKeyDown(e) {
        var which = e.which;

        if (which === Keys.ENTER) {
          e.preventDefault();
          e.stopPropagation(); //this prevents the dialog it is in from closing
        }

        if (which === Keys.ESCAPE || which === Keys.TAB) {
          // By default the escape key will not trigger a blur on the
          // input element. It must be done explicitly.
          if (_this2.input != null) {
            _this2.input.blur();
          }

          e.preventDefault();
          e.stopPropagation(); //this prevents dialog's it is in from closing
        }
      }
    }, _extends({
      onItemSelect: this.handleItemSelect,
      noResults: null,
      resetOnSelect: false,
      onQueryChange: this.onQueryChange,
      itemRenderer: this.itemRenderer,
      itemPredicate: this.itemPredicate,
      selectedItem: value,
      inputValueRenderer: this.renderInputValue,
      inputProps: _extends({
        inputRef: function inputRef(n) {
          if (n) _this2.input = n;
        },
        placeholder: placeholder || "Type here...",
        disabled: disabled,
        // tg: adding isLoading will cause the input to be blurred when using generic select asReactSelect (don't do it),
        intent: this.props.intent
      }, inputProps)
    }, rest)));
  };

  return TgSuggest;
}(React.Component);

_defineProperty(TgSuggest, "defaultProps", {
  onChange: function onChange() {},
  options: [],
  value: undefined
});

export default TgSuggest;
export var singleItemPredicate = function singleItemPredicate(queryString, item, isSimpleSearch) {
  if (item === void 0) {
    item = "";
  }

  return (isSimpleSearch ? simplesearch : fuzzysearch)(queryString.toLowerCase(), item.toLowerCase() || "");
};

function simplesearch(needle, haystack) {
  return (haystack || "").indexOf(needle) !== -1;
}